import React, { useState, useEffect, useRef, useCallback } from "react";
import "./InfiniteRepeatIndicator.css";

const InfiniteRepeatIndicator = ({ isActive, onClose }) => {
  const timeoutRef = useRef(null);
  const boxRef = useRef(null);

  // مدیریت timeout برای بستن خودکار بعد از 3 ثانیه
  useEffect(() => {
    if (isActive) {
      // ریست تایمر قبلی
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // تایمر جدید برای بستن خودکار
      timeoutRef.current = setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 3000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isActive, onClose]);

  const handleBoxClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!isActive) return null;

  return (
    <div
      className="infinite-repeat-indicator"
      onClick={handleBoxClick}
      ref={boxRef}
    >
      <div className="infinite-repeat-indicator-header">
        <span>تکرار بی‌نهایت</span>
        <button
          className="infinite-repeat-indicator-close"
          onClick={handleClose}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="infinite-repeat-indicator-content">
        <div className="infinite-repeat-icon">
          <i className="fas fa-infinity"></i>
        </div>
        <div className="infinite-repeat-message">
          🔁 تکرار بی‌نهایت فعال است
        </div>
        <div className="infinite-repeat-hint">
          برای توقف کلید Shift+S را بزنید
        </div>
      </div>
    </div>
  );
};

export default InfiniteRepeatIndicator;
